import Flex from '@eversports/react-components/primitives/Flex'
import OrderedList from '@eversports/react-components/primitives/OrderedList'
import Text from '@eversports/react-components/primitives/Text'
import React from 'react'

import { Localized } from '../../localization/react'
import Venue from '../../typings/Venue'

interface Props {
  hasSelfCheckIn: boolean
  venue: Venue
  className?: string
}

/* eslint-disable react/jsx-key */
const selfCheckInSteps: Array<React.ReactElement> = [
  <Localized id="app-promotion-content-self-check-in-step-1" />,
  <Localized id="app-promotion-content-self-check-in-step-2" />,
  <Localized id="app-promotion-content-self-check-in-step-3" />,
]

const AppPromotionContent: React.FC<React.PropsWithChildren<Props>> = ({ hasSelfCheckIn, className, venue }) =>
  hasSelfCheckIn ? (
    <Flex justifyContent={['center', 'center', 'flex-start']} className={className}>
      <OrderedList interpunct="dot">
        {selfCheckInSteps.map((step, i) => (
          <Text key={i}>{step}</Text>
        ))}
      </OrderedList>
    </Flex>
  ) : (
    <Text is="span" textAlign={['center', 'left']} className={className}>
      <Localized id="app-promotion-content" params={{ venue: venue ? venue.name : '' }} />
    </Text>
  )

export default AppPromotionContent
